import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {CollapsibleTrigger} from '@radix-ui/react-collapsible';

export const Trigger = styled(CollapsibleTrigger)(
  ({theme}) => css`
    padding: 0;
    align-self: flex-end;
    margin: 0 4px 4px 0;
    justify-content: space-between;

    &:hover,
    &:active {
      background: transparent !important;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.borderSelection};
      outline-offset: 1px;
    }
  `
);
